import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import {Grid} from '@mui/material';
import {useState} from 'react';
import styles from 'assets/jss/AgentStyles/DashboardStyle';
import {makeStyles} from '@mui/styles';
import EditForm from './EditForm';
import CloseIcon from '@mui/icons-material/Close';
const useStyles = makeStyles(styles);

export default function EditProfileModal(props) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  };
  const closeFormAfterReq = () => setOpen(false);

  return (
    <>
      <span onClick={handleOpen}>{props.children}</span>
      <Modal
        aria-labelledby='transition-modal-title'
        aria-describedby='transition-modal-description'
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        hideBackdrop>
        <>
          <Backdrop
            sx={{
              background: 'rgba(112, 112, 112, 0.5)',
              backdropFilter: 'blur(6.7957px)',
              transition: 'ease-in-out 0.2s !important',
            }}
            open={open}
            onClick={() => handleClose()}
          />
          <Fade in={open}>
            <Grid container className={classes.modalContainer}>
              <CloseIcon
                className={classes.closeIconStyle}
                onClick={handleClose}
              />
              <span className={classes.editHeader}>ویرایش</span>
              <EditForm handleCloseModal={closeFormAfterReq} />
            </Grid>
          </Fade>
        </>
      </Modal>
    </>
  );
}
